import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import QRCode from "react-qr-code";
import PageTitle from "../pages/PageTitle";
import { useNavigate, useParams } from "react-router-dom";
import { getGateEntryAPIURL, saveGateEntryAPIURL, updateGateEntryAPIURL } from "../commonServices/TankerEntryAPIURL";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../pages/Loader";
import { useSelector } from "react-redux";

const TankerEntryForm = () => {
    const authUser = useSelector((state) => state.auth.user);

    const navigate = useNavigate();

    const { EditFlag, tId } = useParams();

    const [loader, setLoader] = useState(false);


    // console.log(EditFlag);

    // ---------- FORM & AUTO DATE ----------

    const formik = useFormik({
        initialValues: {
            dateTime: new Date(), // AUTO DATE TIME
            truckNo: "",
            societyId: "",
            routeNo: "",
            compartments: "",
        },

        validationSchema: Yup.object({
            dateTime: Yup.date().required("Date & time is required"),
            // better as string because of MH10 GC 9985
            truckNo: Yup.string().required("Truck number is required"),
            societyId: Yup.number().required("Society ID is required"),
            routeNo: Yup.number().required("Route number is required"),
            compartments: Yup.number().required("Compartments required"),
        }),

        onSubmit: async (values) => {
            if (!authUser?.token || authUser.token.trim() === "") {
                toast.error("Authorization token missing!");
                return; // 🔥 Stop here — do not call API
            }

            setLoader(true);
            const dt = new Date(values.dateTime);
            const pad = (n) => String(n).padStart(2, "0");

            const entryDate = `${dt.getFullYear()}-${pad(dt.getMonth() + 1)}-${pad(dt.getDate())}`;
            const entryTime = `${pad(dt.getHours())}:${pad(dt.getMinutes())}:${pad(dt.getSeconds())}`;

            const payload = {
                id: Number(tId),  // needed for update
                truckNo: values.truckNo,
                routeNo: Number(values.routeNo),
                societyId: Number(values.societyId),
                compartments: Number(values.compartments),
                entryDate,
                entryTime,
            };

            try {

                let resp;

                if (Number(EditFlag) == 1) {
                    // ----------- SAVE API -----------
                    resp = await axios.post(saveGateEntryAPIURL, payload, {
                        headers: {
                            'Authorization': `Bearer ${authUser.token}`,   // 👈 Add token here
                            // OR if your API expects another header name:
                            // "x-access-token": authUser.token
                        }
                    });

                    if (resp.data == "SAVED") {
                        setLoader(false);
                        toast.success("Saved successfully!");
                    }

                } else if (Number(EditFlag) == 2) {
                    // ----------- UPDATE API -----------
                    resp = await axios.put(updateGateEntryAPIURL, payload, {
                        headers: {
                            'Authorization': `Bearer ${authUser.token}`,   // 👈 Add token here
                            // OR if your API expects another header name:
                            // "x-access-token": authUser.token
                        }
                    });

                    if (resp.data == "UPDATED") {
                        setLoader(false);
                        toast.success("Updated successfully!");
                    }
                }

                navigate("/app/gate-entry");

            } catch (err) {
                console.error(err);
                setLoader(false);
                toast.error("Operation failed!");
            }
        },


    });
    // Force update auto date-time on page load
    useEffect(() => {
        // Set initial date immediately
        formik.setFieldValue("dateTime", new Date());

        // Update after every 1 minute
        const interval = setInterval(() => {
            formik.setFieldValue("dateTime", new Date());
        }, 60000);

        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        if (Number(EditFlag) == 2) {
            getEditDetails();
        }
    }, [EditFlag]);



    const getEditDetails = async () => {
        if (!authUser?.token || authUser.token.trim() === "") {
            toast.error("Authorization token missing!");
            return; // 🔥 Stop here — do not call API
        }

        setLoader(true);
        try {
            const resp = await axios.get(getGateEntryAPIURL, {
                headers: {
                    'Authorization': `Bearer ${authUser.token}`,   // 👈 Add token here
                    // OR if your API expects another header name:
                    // "x-access-token": authUser.token
                }
            });

            if (Array.isArray(resp.data) && resp.data.length > 0) {

                // find object by ID
                const record = resp.data.find(item => item.id == tId);

                if (!record) {
                    setLoader(false);
                    console.error("Record not found!");
                    return;
                }

                // console.log(resp.data)
                // Merge date + time into JS Date
                const dateTimeString = `${record.entryDate} ${record.entryTime}`;
                const dateTimeObj = new Date(dateTimeString);

                // Set all fields into formik
                formik.setValues({
                    dateTime: dateTimeObj,
                    truckNo: record.truckNo,
                    routeNo: record.routeNo,
                    societyId: record.societyId,
                    compartments: record.compartments
                });
                setLoader(false);
            }
        } catch (error) {
            console.error("Error fetching entry:", error);
        }
    };






    return (
        <>
            {
                loader == true
                    ?
                    <Loader />
                    :
                    <>
                        <PageTitle title="Gate Entry" />

                        <div className="bg-white shadow-md rounded-xl p-6 mx-auto w-full min-h-[300px]">

                            <form onSubmit={formik.handleSubmit} className="space-y-6">

                                {/* == FIRST ROW == */}
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                                    {/* DATE & TIME */}
                                    <div className="flex flex-col w-full">
                                        <div className="flex flex-col md:flex-row md:items-center">
                                            <label style={{ fontSize: "15px" }} className="md:w-40 font-semibold mt-2 md:mt-0">Date & Time :</label>

                                            <DatePicker
                                                selected={formik.values.dateTime}
                                                onChange={(value) => formik.setFieldValue("dateTime", value)}
                                                showTimeSelect
                                                timeIntervals={1}
                                                dateFormat="dd/MM/yyyy HH:mm"
                                                className="border rounded-md px-3 py-2 w-full md:w-[220px]"
                                            />
                                        </div>

                                        {formik.touched.dateTime && formik.errors.dateTime && (
                                            <p className="text-red-500 text-sm mt-1">{formik.errors.dateTime}</p>
                                        )}
                                    </div>

                                    {/* TRUCK NO */}
                                    <div className="flex flex-col w-full">
                                        <div className="flex flex-col md:flex-row md:items-center">
                                            <label style={{ fontSize: "15px" }} className="md:w-48 font-semibold mt-2 md:mt-0">Truck No :</label>

                                            <input
                                                type="text"
                                                name="truckNo"
                                                placeholder="Truck No"
                                                autoComplete="off"
                                                onChange={formik.handleChange}
                                                value={formik.values.truckNo}
                                                className="border rounded-md px-3 py-2 w-full md:w-[220px]"
                                            />
                                        </div>

                                        {formik.touched.truckNo && formik.errors.truckNo && (
                                            <p className="text-red-500 text-sm mt-1">{formik.errors.truckNo}</p>
                                        )}
                                    </div>

                                    {/* ROUTE NO */}
                                    <div className="flex flex-col w-full">
                                        <div className="flex flex-col md:flex-row md:items-center">
                                            <label style={{ fontSize: "15px" }} className="md:w-40 font-semibold mt-2 md:mt-0">Route No :</label>

                                            <input
                                                type="number"
                                                name="routeNo"
                                                placeholder="Route No"
                                                autoComplete="off"
                                                value={formik.values.routeNo}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value.length <= 6) {
                                                        formik.setFieldValue("routeNo", value);
                                                    }
                                                }}
                                                className="border rounded-md px-3 py-2 w-full md:w-[220px]"
                                            />
                                        </div>

                                        {formik.touched.routeNo && formik.errors.routeNo && (
                                            <p className="text-red-500 text-sm mt-1">{formik.errors.routeNo}</p>
                                        )}
                                    </div>
                                </div>

                                {/* == SECOND ROW == */}
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

                                    {/* SOCIETY ID */}
                                    <div className="flex flex-col w-full">
                                        <div className="flex flex-col md:flex-row md:items-center">
                                            <label style={{ fontSize: "15px" }} className="md:w-40 font-semibold mt-2 md:mt-0">Society Id :</label>

                                            <input
                                                type="number"
                                                name="societyId"
                                                placeholder="Society Id"
                                                autoComplete="off"
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    if (value.length <= 8) {
                                                        formik.setFieldValue("societyId", value);
                                                    }
                                                }}
                                                value={formik.values.societyId}
                                                className="border rounded-md px-3 py-2 w-full md:w-[220px]"
                                            />
                                        </div>

                                        {formik.touched.societyId && formik.errors.societyId && (
                                            <p className="text-red-500 text-sm mt-1">{formik.errors.societyId}</p>
                                        )}
                                    </div>

                                    {/* COMPARTMENTS */}
                                    <div className="flex flex-col w-full">
                                        <div className="flex flex-col md:flex-row md:items-center">
                                            <label style={{ fontSize: "15px" }} className="md:w-48 font-semibold mt-2 md:mt-0">No. Of Compartments :</label>

                                            <input
                                                type="number"
                                                name="compartments"
                                                placeholder="No. Of Compartments"
                                                autoComplete="off"
                                                onChange={formik.handleChange}
                                                value={formik.values.compartments}
                                                className="border rounded-md px-3 py-2 w-full md:w-[220px]"
                                            />
                                        </div>

                                        {formik.touched.compartments && formik.errors.compartments && (
                                            <p className="text-red-500 text-sm mt-1">{formik.errors.compartments}</p>
                                        )}
                                    </div>

                                </div>

                                {/* BUTTONS */}
                                <div className="pt-3 flex flex-col sm:flex-row gap-3 ml-auto sm:ml-40">
                                    <button
                                        type="submit"
                                        className="bg-indigo-600 text-white px-2 py-2 rounded-md hover:bg-indigo-700 transition w-full sm:w-28"
                                    >
                                        {Number(EditFlag) === 1 ? "Save" : "Update"}
                                    </button>

                                    <button
                                        type="button"
                                        className="bg-red-500 text-white px-2 py-2 rounded-md hover:bg-red-600 transition w-full sm:w-28"
                                        onClick={() => navigate(`/app/gate-entry/`)}
                                    >
                                        Cancel
                                    </button>
                                </div>


                            </form>
                        </div>


                        {/* ---------- QR MODAL (MODIFIED) ---------- */}
                        {/* {showModal && (
                <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center">
                    <div className="bg-white p-6 rounded-lg shadow-lg w-96 text-center">
                        <h2 className="text-xl font-semibold mb-4">Generated QR Code</h2>

                        <div className="bg-gray-100 p-4 rounded-lg flex justify-center">
                            <QRCode value={qrUrl} size={180} />
                        </div>

                        <button
                            className="mt-4 bg-green-600 text-white px-6 py-2 rounded-md w-full"
                            onClick={saveQrEntry}
                        >
                            Save QR Entry
                        </button>

                        <button
                            className="mt-3 bg-indigo-600 text-white px-6 py-2 rounded-md w-full"
                            onClick={() => setShowModal(false)}
                        >
                            Close
                        </button>
                    </div>
                </div>
            )} */}
                    </>
            }
        </>
    );
};

export default TankerEntryForm;
